(function(){
    'use strict';

    var $print = $('.smp-print');

    if($print.length){

        var $printButton = $print.find('.print'),
            $socialButton = $print.find('.social'),
            $dropdown = $print.find('.smp-print__dropdown');

        $printButton.on('click',function(){
            window.print();
        });

        $socialButton.on('click',function(){
            $dropdown.toggleClass('active');
        });

        $(document).on('click', function(e){
            if($dropdown.hasClass('active') && !$(e.target).hasClass('social')) {
                $dropdown.removeClass('active');
            }
        });
    }


}());
